import { render, staticRenderFns } from "./Overview.vue?vue&type=template&id=50daeb87&scoped=true&"
import script from "./Overview.vue?vue&type=script&lang=js&"
export * from "./Overview.vue?vue&type=script&lang=js&"
import style0 from "./Overview.vue?vue&type=style&index=0&id=50daeb87&prod&lang=scss&scoped=true&"
import style1 from "./Overview.vue?vue&type=style&index=1&id=50daeb87&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50daeb87",
  null
  
)

export default component.exports